module.exports = __webpack_public_path__ + "static/media/fashion-webstore.ee3d056b.png";